import { Firebase } from "../../redux/configureStore";
import getUtcTimestamp from "../TradingView/getUtcTimestamp";

class QuoteStreamService {
  _streams = new Map();

  getStreamKey(stockId, intervalTypeId) {
    return `${stockId}/${intervalTypeId}`;
  }

  normalizeQuoteData(quoteData) {
    if (!quoteData) {
      return quoteData;
    }

    const normalizedQuoteData = {
      ...quoteData
    };

    if (normalizedQuoteData.datetime_utc) {
      normalizedQuoteData.time = getUtcTimestamp(
        new Date(normalizedQuoteData.datetime_utc)
      );
    }

    const close = Number(normalizedQuoteData.close);
    const change = Number(normalizedQuoteData.change);

    if (!Number.isNaN(close) && !Number.isNaN(change) && change !== -1) {
      const prevClose = close / (1 + change);
      const changeValue = close - prevClose;
      // snake_case and String value type to keep convention
      normalizedQuoteData.change_value = String(changeValue);
    }

    return normalizedQuoteData;
  }

  subscribe({ stockId, intervalTypeId, onQuote }) {
    if (!stockId || !intervalTypeId || typeof onQuote !== "function") {
      return () => {};
    }

    const streamKey = this.getStreamKey(stockId, intervalTypeId);
    let streamEntry = this._streams.get(streamKey);

    if (!streamEntry) {
      const quoteRef = Firebase.database()
        .ref("quotes")
        .child(stockId)
        .child(intervalTypeId);

      streamEntry = {
        quoteRef,
        listeners: new Set(),
        lastQuoteData: null
      };

      streamEntry.valueHandler = quoteSnapshot => {
        if (!quoteSnapshot) {
          return;
        }

        const quoteData = quoteSnapshot.val();

        // Keep callbacks out of Firebase dispatch cycle.
        setTimeout(() => {
          const normalizedQuoteData = this.normalizeQuoteData(quoteData);

          if (!normalizedQuoteData) {
            return;
          }

          streamEntry.lastQuoteData = normalizedQuoteData;
          streamEntry.listeners.forEach(listener => listener(normalizedQuoteData));
        });
      };

      quoteRef.on("value", streamEntry.valueHandler);
      this._streams.set(streamKey, streamEntry);
    }

    streamEntry.listeners.add(onQuote);

    if (streamEntry.lastQuoteData) {
      onQuote(streamEntry.lastQuoteData);
    }

    return () => {
      const currentEntry = this._streams.get(streamKey);
      if (!currentEntry) {
        return;
      }

      currentEntry.listeners.delete(onQuote);

      if (currentEntry.listeners.size === 0) {
        currentEntry.quoteRef.off("value", currentEntry.valueHandler);
        this._streams.delete(streamKey);
      }
    };
  }
}

const quoteStreamService = new QuoteStreamService();

export default quoteStreamService;
